module.exports = __webpack_public_path__ + "static/img/pic-banner-course@2x.88b4dcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listitem/pic-banner-course@2x.png
// module id = 170
// module chunks = 0